// extracted by mini-css-extract-plugin
export var button = "favorite-button-module--button--d9de5";
export var corner = "favorite-button-module--corner--2157c";
export var icon = "favorite-button-module--icon--ca855";
export var root = "favorite-button-module--root--890c6";
export var sizeMedium = "favorite-button-module--sizeMedium--cf88d";
export var sizeSmall = "favorite-button-module--sizeSmall--d3813";